var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"disparity",class:{'is-up': _vm.disparity > 0, 'is-down': _vm.disparity < 0}},[(_vm.disparity < 0)?_c('span',[_vm._v("-")]):_vm._e(),(_vm.disparity > 0)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm._f("round")(_vm._f("abs")(_vm.disparity),1, true))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }